import store from '@/store';

export const webinarSingleUseAllowed = window.newBillingConfig?.webinarSingleUseAllowed || false;

export const getEnableWebinar300 = () => {
  return store.getters?.enableWebinar300 || window.newBillingConfig?.enableWebinar300 || false;
};

export const getEnableOnlineRemoveWebinar10000 = () => {
  return store.getters?.enableOnlineRemoveWebinar10000 || window.newBillingConfig?.enableOnlineRemoveWebinar10000 || false;
};

export const enableWebinar300 = getEnableWebinar300;
export const enableOnlineRemoveWebinar10000 = getEnableOnlineRemoveWebinar10000;
